<template>
  <VpListLayout>
    <VpList
      :per-page="10"
      :columns="[]"
      endpoint="message-images"
      :filters.sync="filters"
      :params="params"
      class="saved vp-h-full saved--image"
      ref="list"
      title="Images"
      :search="false"
      :settings="false"
      feature="MESSAGE"
      cache="messages"
      :request-payload="{ query: $options.messagesQuery }"
    >
      <template #empty>
        <VpErrorPage
          title="Image Not Found!"
          desc="All images saved from WhatsApp Web using the Vepaar extension's save button will be displayed here."
        />
      </template>

      <template #filters>
        <VpDateRangePicker
          stack
          label="Order Date"
          :value="[filters.startDate, filters.endDate]"
          @input="
            filters.startDate =
              $event[0] ?? String(Math.floor(new Date().getTime() / 1000));
            filters.endDate =
              $event[1] ?? String(Math.floor(new Date().getTime() / 1000));
          "
        />

        <VpField label="Tags">
          <TagsInput v-model="filters.tags" type="image" />
        </VpField>
      </template>

      <template #default="{ items }">
        <div class="vp-bg-gray-100">
          <div
            class="vp-grid vp-grid-cols-2 xl:vp-grid-cols-3 vp-gap-2 vp-p-6 vp-whitespace-nowrap"
          >
            <template v-for="(item, index) in items">
              <MessageSaved
                :key="item.id + '-' + index"
                :data="item"
                type="image"
                @click="open(item)"
              />
            </template>
          </div>
        </div>
      </template>
    </VpList>

    <MessageModal
      type="image"
      :data="openMessage"
      @refresh="$refs.list.refresh()"
    />
  </VpListLayout>
</template>

<script>
import TagsInput from "components/src/tags/input.vue";
import messagesQuery from "@/views/crm/messages/collection.gql";

import MessageModal from "../_Modal.vue";
import MessageSaved from "../_Saved.vue";

export default {
  messagesQuery,
  components: {
    MessageSaved,
    MessageModal,
    TagsInput,
  },
  data() {
    return {
      filters: {
        startDate: null,
        endDate: null,
        tags: [],
      },
      openMessage: null,
    };
  },
  computed: {
    params() {
      return {
        type: "image",
        //TODO: Apply direction filter
        //direction: 2,
      };
    },
  },
  methods: {
    open(message) {
      this.openMessage = message;
      this.$nextTick(() => {
        this.$vayu.modal.open("saved-modal");
      });
    },
  },
};
</script>
